module.exports = __webpack_public_path__ + "static/media/finish.c676676e.jpg";